import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FactorId } from "@firebase/auth";
import { Icon, Popup } from "semantic-ui-react";
const FACTOR_ICONS = {
    [FactorId.PHONE]: "mobile alternate",
    [FactorId.TOTP]: "clock outline",
};
export function MultiFactorAuthIcons({ user }) {
    if (!(Array.isArray(user === null || user === void 0 ? void 0 : user.enrolledFactors) && user.enrolledFactors.length > 0)) {
        return null;
    }
    return (_jsx("div", { children: user.enrolledFactors.map((factor, i) => {
            var _a;
            return (_jsx(Popup, { flowing: true, trigger: _jsx(Icon, { name: (_a = FACTOR_ICONS[factor.factorId]) !== null && _a !== void 0 ? _a : "question circle", size: "large", color: "grey" }), content: _jsx(_Fragment, { children: factor.factorId }) }, factor.factorId + i));
        }) }));
}
